import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { HelpSlide, HelpSlides } from 'src/model/class/general classes/help-slides';
import { iEvent } from 'src/components/shared-components/interfaces/iEvent';
import { iTranslation } from 'src/components/shared-components/interfaces/iTranslation';
import { AuthenticationService } from 'src/service/authentication.service';
import { EventService } from 'src/service/event.service';
import { helpMessagesID as helpMessageID, helpMessagesID } from 'src/service/helper.service';
import { LocalStorageService } from 'src/service/local-storage.service';
import { TranslationService } from 'src/service/translation.service';


@Component({
    selector: 'app-help-slide',
    templateUrl: './help-slide.component.html',
    styleUrls: ['./help-slide.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class HelpSlideComponent implements OnInit, OnDestroy, iTranslation, iEvent {
  @Input() HelpMessageID: helpMessageID;

  public helpMessageId = helpMessagesID;

  public Slides: HelpSlides = new HelpSlides();
  public slideOpts = {
    initialSlide: 1,
    speed: 400
  };

  //translateSubscription: Subscription;
  public _eventSubscriptions: Array<Subscription> = null;
  private _translateSubscription: Subscription = null;
  private _lblReorder = "Riordino elementi";
  private _lblReorderDesc = "Attivando questa funzione puoi riordinare gli elementi della supervisione trascinandoli nella posizione che preferisci. Ricordati di disattivare la funzione al termine e che la configurazione che stai facendo vale solo per questo dispositivo!";
  private _lblLoadControl = "Controllo carichi";
  private _lblLoadControlDesc = "Monitoraggio della potenza assorbita in modo da impedire che, nel caso di accensioni contemporanee di più elettrodomestici, si verifichi un sovraccarico tale da provocare il distacco dell’interruttore generale (blackout). " +
    "Quando necessario, lo strumento provvede al distacco in sequenza dei carichi ritenuti non prioritari per evitare che la potenza assorbita sia superiore alla soglia impostata e causi di conseguenza il blackout. ";

  constructor(private _modalCtrl: ModalController,
    private _translateService: TranslateService,
    private _eventService: EventService
  ) {
    //this.translationSub();
  }

  ngOnInit() {
    this.loadTranslation();
    this.subscribeTranslationEvent();
    this.subscribeEvents();
    this.ShowHelpInfo();
  }

  ngOnDestroy() {
    this._translateSubscription.unsubscribe();
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalCtrl.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  //#region Translation
  public loadTranslation(): void {

    this._translateService.get([
      "dictionary.elementReorder",
      "dictionary.reorderMessage",
      "dictionary.loadControl",
      "dictionary.helperLoadControl"
    ]).subscribe((translation) => {
      this._lblReorder = translation["dictionary.elementReorder"];
      this._lblReorderDesc = translation["dictionary.reorderMessage"];
      this._lblLoadControl = translation["dictionary.loadControl"];
      this._lblLoadControlDesc = translation["dictionary.helperLoadControl"];
    });
  }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(() => {
      this.loadTranslation();
    });

  }
  //#endregion

  /**
   * Load the help message with the informations to show
   */
  private ShowHelpInfo() {
    switch (this.HelpMessageID) {
      case helpMessagesID.ReorderElements:
        this.Slides = new HelpSlides();
        this.Slides.slides.push(new HelpSlide(this._lblReorder, this._lblReorderDesc))
        break;
      case helpMessageID.LoadControl:
        this.Slides = new HelpSlides();
        this.Slides.slides.push(new HelpSlide(this._lblLoadControl, this._lblLoadControlDesc))
      default:
        break;
    }
  }

  /**
   * Handle the close of the message
   * @param showAgain the user chooses to show again the help message
   */
  public ExitSlides(showAgain: boolean) {
    this._modalCtrl.dismiss({ 'showAgain': showAgain });
  }

}
